{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "ID",
      "folder": "Land Posting Header",
      "width": 185,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "agreement_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Title/Agreement No.",
      "folder": "Land Posting Header",
      "width": 150,
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "agreement_type_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Agreement Type ID",
      "folder": "Land Posting Header",
      "tnum": true,
    },
  },
  "contract_no": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Parcel",
      "folder": "Land Posting Header",
      "tnum": true,
    },
  },
  "tracts": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Tract",
      "folder": "Land Posting Header",
      "width": 75,
      "isShownByDefault": true,
      "isNotSortable": true,
      "tnum": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["AB", "BC", "MB", "SK"],
    },
    "ui": {
      "label": "Province",
      "folder": "Land Posting Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "land_ids": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Land IDs",
      "folder": "Land Posting Header",
      "width": 175,
      "isShownByDefault": true,
      "isNotSortable": true,
      "tnum": true,
    },
  },
  "zones": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Zones",
      "folder": "Land Posting Header",
      "width": 270,
      "isShownByDefault": true,
      "isNotSortable": true,
    },
  },
  "agreement_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Agreement Type",
      "folder": "Land Posting Header",
      "width": 200,
    },
  },
  "pn_agreement_type": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": [
        "PNG",
        "OS",
        "Coal",
        "Metal",
        "Geothermal",
        "CO2",
        "Helium",
        "Brine",
      ],
    },
    "ui": {
      "label": "Stack Maps Agreement Type",
      "folder": "Land Posting Header",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Status",
      "folder": "Land Posting Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "sale_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Sale Date",
      "folder": "Land Posting Header",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "expiry_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Expiry Date",
      "folder": "Land Posting Header",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "area": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ha",
    },
    "ui": {
      "label": "Area",
      "folder": "Land Posting Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "term_length": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Term Length",
      "folder": "Land Posting Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
